import React, { useState } from 'react';
import { InputField } from '../../components/reusable/InputField';
import Close from '../../assets/svg/CloseButton.svg';
import FileInput from '../../components/reusable/FileInput';
import SyriaFlag from '../../assets/svg/SyriaFlag.svg';
import UKFlag from '../../assets/svg/UKFlag.svg';

const EditProfile = ({ handleUpdateInfo, onClose, userDetails }) => {
    const [formData, setFormData] = useState({
        name: userDetails.name,
        email: userDetails.email,
        phone_number: userDetails.phone_number,
        username: userDetails.username,
        lang: userDetails.lang,
        image_url: userDetails.image_url,
    });
    const [formErrors, setFormErrors] = useState({});

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image_url') {
            setFormData({ ...formData, [name]: files[0] }); // Handle file upload
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            data.append(key, value);
        });

        handleUpdateInfo(data, setFormErrors);
    };

    return (
        <div className="relative p-4 w-full max-w-3xl mx-auto">
            <div className="flex justify-between items-center pb-4 mb-4 border-b dark:border-gray-600">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Edit Your Profile Information
                </h3>
                <button
                    onClick={onClose}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-1.5"
                >
                    <img className="w-6 h-6" src={Close} alt="Close" />
                </button>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="grid gap-4 mb-4 sm:grid-cols-2">
                    <InputField
                        label="Full Name"
                        name="name"
                        placeholder="Type full name"
                        value={formData.name}
                        handleChange={handleChange}
                        error={formErrors.name}
                    />
                    <InputField
                        label="Email"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        handleChange={handleChange}
                        error={formErrors.email}
                    />
                    <InputField
                        label="Mobile Number"
                        name="phone_number"
                        type="text"
                        placeholder="Your Mobile Number"
                        value={formData.phone_number}
                        handleChange={handleChange}
                        error={formErrors.phone_number}
                    />
                    <InputField
                        label="Username"
                        name="username"
                        type="text"
                        placeholder="Your Username"
                        atSign={true}
                        value={formData.username}
                        handleChange={handleChange}
                        error={formErrors.username}
                    />
                    <div className="flex items-center mb-4 space-x-4 sm:space-x-6">
                        <label className="flex items-center space-x-2">
                            <input
                                id="lang-en"
                                type="radio"
                                value="en"
                                name="lang"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
                                checked={formData.lang === 'en'}
                                onChange={handleChange}
                            />
                            <img
                                src={UKFlag}
                                alt="uk flag"
                                className="w-10 h-6 sm:w-14 sm:h-8 rounded-lg shadow-lg"
                            />
                        </label>
                        <label className="flex items-center space-x-2">
                            <input
                                id="lang-ar"
                                type="radio"
                                value="ar"
                                name="lang"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
                                checked={formData.lang === 'ar'}
                                onChange={handleChange}
                            />
                            <img
                                src={SyriaFlag}
                                alt="syrian flag"
                                className="w-10 h-6 sm:w-14 sm:h-8 rounded-lg shadow-lg"
                            />
                        </label>
                    </div>
                    <div className="sm:col-span-2">
                        <FileInput id="image_url" onChange={handleChange} oldValue={userDetails.image_url} aspect={1} cropRequired={true} />
                    </div>
                </div>
                <div className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                    <span className="font-semibold">Notes:</span>
                    <p>When you change your email, you have to verify your account again.</p>
                </div>
                <div className="flex justify-end">
                    <button
                        type="submit"
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        Update
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditProfile;